/**
 * Year-based holiday registry. To add a future year, create `2027.js`
 * exporting `HOLIDAYS_2027` and register it in HOLIDAYS_BY_YEAR below.
 * No other code needs to change.
 */
import { HOLIDAYS_2026 } from './2026';
import { HOLIDAYS_2027 } from './2027';

export const HOLIDAYS_BY_YEAR = {
  2026: HOLIDAYS_2026,
  2027: HOLIDAYS_2027,
};

export const AVAILABLE_HOLIDAY_YEARS = Object.keys(HOLIDAYS_BY_YEAR)
  .map(Number)
  .sort((a, b) => a - b);

export const getHolidays = (year) => HOLIDAYS_BY_YEAR[year] || [];

// National + Andalucía holidays apply everywhere, so they are safe to show on
// any calendar without knowing the municipality. Local holidays are town-specific
// and are intentionally EXCLUDED here (a calendar has no reliable municipality).
export const getUniversalHolidaysByDate = (year) => {
  const map = {};
  for (const h of getHolidays(year)) {
    if (h.scope === 'national' || h.scope === 'andalusia') {
      (map[h.date] = map[h.date] || []).push(h);
    }
  }
  return map;
};
